import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'

const COLOR_SCHEMES = {
  // default, metabar, navigation
  grayOnWhite:
    'shade-20 shade-10-on-hover background-shade-50-on-hover background-shade-45-on-active',
  grayOnWhiteDisabled: 'shade-40',
  // default, metabar, navigation
  grayOnGray:
    'shade-20 shade-10-on-hover background-shade-40-on-hover background-shade-30-on-active',
  lightGrayOnGray:
    'shade-30 shade-20-on-hover background-shade-40-on-hover background-shade-30-on-active',
  grayOnGrayDisabled: 'shade-40',
  // order by recent in note list
  whiteOnPrimary:
    'background-primary shade-00 inset-shadow-on-hover background-primary-dark-on-active',
  primaryOnWhite:
    'background-primary-shade-light background-primary-shade-light-on-active background-primary-shade-dark-on-hover primary',
  primaryOnWhiteDisabled: 'primary',
  // quick switch
  whiteOnDark: 'shade-10 shade-05-on-hover background-shade-50-on-hover',
  whiteOnDarkDisabled: 'opacity-large',
}

const BOX_SIZES = {
  smaller: 20,
  small: 24,
  default: 32,
}

export default function IconButton({
  boxSize = 'default',
  className = '',
  tooltip = null,
  tooltipPosition = 'bottom',
  children,
  style = undefined,
  colorScheme = 'grayOnWhite',
  disabled = false,
  ...otherProps
}) {
  const _style = {
    width: BOX_SIZES[boxSize],
    height: BOX_SIZES[boxSize],
    ...style,
  }

  const enhancedClassName = classNames(
    'flexbox',
    { pointer: !disabled },
    'transition',
    'flexbox-centered',
    'radius-normal',
    disabled
      ? COLOR_SCHEMES[`${colorScheme}Disabled`]
      : COLOR_SCHEMES[colorScheme],
    className
  )
  const content = (
    <div className="inline-block">
      <span className={enhancedClassName} style={_style} {...otherProps}>
        {children}
      </span>
    </div>
  )

  return !tooltip ? (
    content
  ) : (
    <TooltipOnHover
      id="tooltip"
      tooltipContent={tooltip}
      placement={tooltipPosition}
    >
      {content}
    </TooltipOnHover>
  )
}

IconButton.propTypes = {
  colorScheme: PropTypes.oneOf(Object.keys(COLOR_SCHEMES)),
  boxSize: PropTypes.oneOf(Object.keys(BOX_SIZES)),
  tooltip: PropTypes.node,
  tooltipPosition: PropTypes.string,
}
